import { Component } from '@angular/core';

@Component({
  selector: 'td-wb-list-item-value',
  template: '<ng-content />',
  styleUrls: ['list-item-value.component.scss']
})
export class ListItemValueComponent {
}
